import Link from 'next/link';
import FutureImage from '../../FutureImage';
import BlogName from './BlogName';
import { nicheSections } from './nameIdeasContent';

// Curated, SSR'd name ideas by niche — the content depth behind the ranking
// generator page. Every chip opens the same availability/claim dialog as the
// generated names.
export default function NicheNameIdeas({ setNameOpen }) {
  return (
    <section className="tw-py-10 tw-bg-gray-50 sm:tw-py-16 lg:tw-py-24">
      <div className="tw-px-4 tw-mx-auto tw-max-w-7xl sm:tw-px-6 lg:tw-px-8">
        <div className="tw-max-w-2xl tw-mx-auto tw-text-center">
          <h2 className="tw-text-3xl tw-font-bold tw-leading-tight tw-text-gray-900 sm:tw-text-4xl lg:tw-text-5xl">
            Travel Blog Name Ideas by Niche
          </h2>
          <p className="tw-max-w-lg tw-mx-auto tw-mt-4 tw-text-base tw-leading-relaxed tw-text-gray-600">
            The best names signal what your blog is about. Start with your niche
            below — click any name to check whether the .com domain and the
            TravelFeed username are still free.
          </p>
        </div>

        <div className="tw-mx-auto tw-mt-10 tw-max-w-3xl">
          <FutureImage
            src="/img/name-ideas/suitcase.jpg"
            alt="Vintage suitcase covered in blank travel stickers, waiting for a name"
            width={1536}
            height={1024}
            sizes="(max-width: 768px) 100vw, 768px"
            className="tw-h-auto tw-w-full tw-rounded-2xl"
          />
        </div>

        {nicheSections.map(section => (
          <div key={section.id} id={section.id} className="tw-pt-14">
            <h3 className="tw-text-2xl tw-font-bold tw-leading-tight tw-text-gray-900 sm:tw-text-3xl">
              {section.title}
            </h3>
            <p className="tw-mt-3 tw-max-w-3xl tw-text-base tw-leading-relaxed tw-text-gray-600">
              {section.intro}
            </p>
            <div className="tw-grid tw-grid-cols-2 sm:tw-grid-cols-3 md:tw-grid-cols-4 tw-gap-2 sm:tw-gap-4 tw-pt-6">
              {section.names.map(blogName => (
                <BlogName
                  key={blogName}
                  name={blogName}
                  setNameOpen={setNameOpen}
                />
              ))}
            </div>
          </div>
        ))}

        <div className="tw-mt-16 tw-rounded-2xl tw-border tw-border-solid tw-border-gray-200 tw-bg-white tw-px-6 tw-py-8 tw-text-center sm:tw-px-10">
          <p className="tw-m-0 tw-text-lg tw-font-semibold tw-text-gray-900">
            Still hunting for the perfect name?
          </p>
          <p className="tw-mx-auto tw-mb-4 tw-mt-2 tw-max-w-xl tw-text-base tw-text-gray-600">
            We put together a much longer list, sorted by style and niche — from
            catchy and funny to couple and family blog names.
          </p>
          <Link
            href="/blog/travel-blog-name-ideas"
            className="tw-font-semibold tw-text-primary-700 hover:tw-underline"
          >
            Browse 300+ travel blog name ideas →
          </Link>
          <p className="tw-mb-0 tw-mt-3 tw-text-sm tw-text-gray-600">
            Already found it? Here&rsquo;s{' '}
            <Link
              href="/start-a-travel-blog"
              className="tw-font-semibold tw-text-primary-700 hover:tw-underline"
            >
              how to start the blog itself
            </Link>
            .
          </p>
        </div>
      </div>
    </section>
  );
}
